import React from 'react';

import Spinner from 'react-spinner-material';
import {
  GraphBarCustomLateral,
  GraphBarGrouped,
  NewGraphBar,
  NewGraphBarPorte,
  PizzaChart,
} from '../../../utils/newGraphsBar';
import styles from './styles.module.scss';

export default function Acessos({
  totalAcessos,
  usuariosUnicosAcessos,
  mediaUsuarioAcessos,
  distribuicaoDiaAcessos,
  perfilUsuarioAcessos,
  porcemPerfilUserAcessos,
  porteAcessos,
  tempoMedioAcessos,
  ufAcessos,

  isLoadingTotalAcessos,
  isLoadingUsuariosUnicosAcessos,
  isLoadingMediaUsuarioAcessos,
  isLoadingDistribuicaoDiaAcessos,
  isLoadingPerfilUsuariosAcessos,
  isLoadingPorcemPerfilUserAcessos,
  isLoadingPorteAcessos,
  isLoadingTempoMedioAcessos,
  isLoadingUfAcessos,
}) {
  const renderTotal = () => (
    <div
      className={isLoadingTotalAcessos ? styles.render_spinner_container : null}
    >
      {isLoadingTotalAcessos && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingTotalAcessos && (
        <NewGraphBar
          dataGraphs={totalAcessos.atendimentos}
          total={
            totalAcessos.total === 0 ||
            totalAcessos.total === 'NaN' ||
            totalAcessos.total === undefined
              ? '0'
              : totalAcessos.total
          }
          label="total"
          position="mes*total"
          subLabel="acessos"
          labelModal="total"
          date={totalAcessos.data}
          otherTitle="Acessos"
        />
      )}
    </div>
  );

  const renderUsuariosUnicos = () => (
    <div
      className={
        isLoadingUsuariosUnicosAcessos ? styles.render_spinner_container : null
      }
    >
      {isLoadingUsuariosUnicosAcessos && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingUsuariosUnicosAcessos && (
        <NewGraphBar
          dataGraphs={usuariosUnicosAcessos.atendimentos}
          total={
            usuariosUnicosAcessos.total === 0 ||
            usuariosUnicosAcessos.total === 'NaN' ||
            usuariosUnicosAcessos.total === undefined
              ? '0'
              : usuariosUnicosAcessos.total
          }
          label="usuários únicos"
          position="mes*total"
          subLabel="usuários únicos"
          labelModal="usuários únicos"
          date={usuariosUnicosAcessos.data}
          otherTitle="Acessos"
        />
      )}
    </div>
  );
  const renderMediaUsuario = () => (
    <div
      className={
        isLoadingMediaUsuarioAcessos ? styles.render_spinner_container : null
      }
    >
      {isLoadingMediaUsuarioAcessos && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingMediaUsuarioAcessos && (
        <NewGraphBar
          dataGraphs={mediaUsuarioAcessos?.mediaDiaria}
          total={
            mediaUsuarioAcessos?.média === 0 ||
            mediaUsuarioAcessos?.média === 'NaN' ||
            mediaUsuarioAcessos?.média === undefined
              ? '0'
              : mediaUsuarioAcessos?.média.toFixed(2)
          }
          label="média por usuário"
          position="mes*média"
          subLabel="acessos por usuário (média)"
          labelModal="média por usuário"
          axisY="média"
          date={mediaUsuarioAcessos?.data}
          otherTitle="Acessos"
        />
      )}
    </div>
  );

  const renderDistribuicaoDia = () => (
    <div
      className={
        isLoadingDistribuicaoDiaAcessos ? styles.render_spinner_container : null
      }
    >
      {isLoadingDistribuicaoDiaAcessos ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={distribuicaoDiaAcessos?.atendimentosHora}
          otherTitle="Acessos"
          total={
            distribuicaoDiaAcessos?.total === 0 ||
            distribuicaoDiaAcessos?.total === 'NaN' ||
            distribuicaoDiaAcessos?.total === undefined ||
            distribuicaoDiaAcessos?.total === null
              ? '0'
              : distribuicaoDiaAcessos?.total
          }
          label="distribuição no dia"
          subLabel={
            distribuicaoDiaAcessos?.horaPico === 0 ||
            distribuicaoDiaAcessos?.horaPico === 'NaN' ||
            distribuicaoDiaAcessos?.horaPico === undefined ||
            distribuicaoDiaAcessos?.horaPico === null
              ? 'acesso das 0h'
              : `acessos das ${distribuicaoDiaAcessos?.horaPico}h`
          }
          labelModal="Distribuição por hora"
          position="hora*total"
          date={distribuicaoDiaAcessos.horaModal}
        />
      )}
    </div>
  );
  const renderPerfilUsuario = () => (
    <div
      className={
        isLoadingPerfilUsuariosAcessos ? styles.render_spinner_container : null
      }
    >
      {isLoadingPerfilUsuariosAcessos && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}

      {!isLoadingPerfilUsuariosAcessos && (
        <GraphBarGrouped
          dataGraphs={perfilUsuarioAcessos?.atendimentos}
          title="Acessos únicos"
          label="perfil do usuário"
          porcemPf={
            perfilUsuarioAcessos?.porcentagemPf === 'NaN' ||
            perfilUsuarioAcessos?.porcentagemPf === undefined ||
            perfilUsuarioAcessos?.porcentagemPf === 0
              ? '0'
              : perfilUsuarioAcessos?.porcentagemPf
          }
          porcemPj={
            perfilUsuarioAcessos?.porcentagemPj === 'NaN' ||
            perfilUsuarioAcessos?.porcentagemPj === undefined ||
            perfilUsuarioAcessos?.porcentagemPj === 0
              ? '0'
              : perfilUsuarioAcessos?.porcentagemPj
          }
          position="dia*total"
          date={perfilUsuarioAcessos?.data}
          iten1="PF"
          iten2="PJ"
          // porcemSimbol="%"
        />
      )}
    </div>
  );

  const renderPorcemPerfilUser = () => (
    <div
      className={
        isLoadingPorcemPerfilUserAcessos
          ? styles.render_spinner_container
          : null
      }
    >
      {isLoadingPorcemPerfilUserAcessos ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <PizzaChart
          item1Pf="PF"
          item2Pj="PJ"
          label="perfil do usuário"
          title="Acessos únicos"
          porcemPf={
            porcemPerfilUserAcessos.porcentagemPf === 'NaN' ||
            porcemPerfilUserAcessos.porcentagemPf === undefined ||
            porcemPerfilUserAcessos.porcentagemPf === 0
              ? '0'
              : porcemPerfilUserAcessos.porcentagemPf
          }
          porcemPj={
            porcemPerfilUserAcessos.porcentagemPj === 'NaN' ||
            porcemPerfilUserAcessos.porcentagemPj === undefined ||
            porcemPerfilUserAcessos.porcentagemPj === 0
              ? '0'
              : porcemPerfilUserAcessos.porcentagemPj
          }
        />
      )}
    </div>
  );

  const renderPorte = () => (
    <div
      className={isLoadingPorteAcessos ? styles.render_spinner_container : null}
    >
      {isLoadingPorteAcessos ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBarPorte
          dataGraphs={porteAcessos.atendimentos}
          title="Acessos"
          total={
            porteAcessos.total === 0 ||
            porteAcessos.total === 'NaN' ||
            porteAcessos.total === undefined
              ? '0'
              : porteAcessos.total
          }
          label="por porte empresa"
          labelModal="por porte"
          subLabel="Usuários únicos (PJ)"
          position="sigla*total"
          slModal={porteAcessos.slModal}
        />
      )}
    </div>
  );

  const renderTempoMedio = () => (
    <div
      className={
        isLoadingTempoMedioAcessos ? styles.render_spinner_container : null
      }
    >
      {isLoadingTempoMedioAcessos && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingTempoMedioAcessos && (
        <NewGraphBar
          dataGraphs={tempoMedioAcessos?.atendimentos}
          total={
            tempoMedioAcessos?.total === 0 ||
            tempoMedioAcessos?.total === 'NaN' ||
            tempoMedioAcessos?.total === undefined
              ? '0'
              : tempoMedioAcessos?.total
          }
          label="tempo médio"
          position="mes*total"
          subLabel="segundos de engajamento"
          labelModal="Tempo médio de acesso"
          date={tempoMedioAcessos?.data}
          otherTitle="Acesso"
        />
      )}
    </div>
  );

  const renderUfAcessos = () => (
    <div
      className={
        isLoadingUfAcessos ? styles.render_spinner_container_ufs : null
      }
    >
      {isLoadingUfAcessos ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <GraphBarCustomLateral
          dataGraphsAtendUf={ufAcessos?.uf}
          dataGraphsUserUf={ufAcessos?.ufUnicos}
          position="uf*total"
          tab1="por UF"
          tab2="únicos UF"
          titleUF2={ufAcessos?.descUfUnicos}
          titleUF={ufAcessos?.descUF}
          otherTitle="Acessos"
        />
      )}
    </div>
  );

  return (
    <div className={styles.central_container}>
      <div className={styles.render_big_container}>
        <div className={styles.render_big_container2}>
          <div className={styles.render_graph_container1}>
            {renderTotal()}
            {renderUsuariosUnicos()}
            {renderMediaUsuario()}
            {renderDistribuicaoDia()}
          </div>
          <div className={styles.render_graph_container1}>
            {renderPerfilUsuario()}
            {renderPorcemPerfilUser()}
            {renderPorte()}
            {renderTempoMedio()}
          </div>
        </div>
        <div className={styles.graphBar_lateral_container}>
          {renderUfAcessos()}
        </div>
      </div>
    </div>
  );
}
